import { useSetAtom } from 'jotai';
import { useDispatch } from 'react-redux';

import { selectedVisitAtom } from '../../../app/appHeader/imageViewerMenu/atoms';
import type { Appointment } from '../../../react-query/useAppointments';
import { updateUserName } from '../../annotator/AnnotatorActions';
import { selectUnifiedIdAtom } from '../atoms';
import { getDisplayName } from '../helpers';

export const useReviewRadiographs = (appointment?: Appointment) => {
  const dispatch = useDispatch();
  const setSelectedVisitId = useSetAtom(selectedVisitAtom);
  const setSelectedUnifiedId = useSetAtom(selectUnifiedIdAtom);

  const imagingPatientId = appointment?.patient?.imagingPatientId || '';
  const estimatedVisitId = appointment?.appointment?.estimatedVisitId;
  const unifiedId = appointment?.appointment?.unifiedId;

  const annotatorUri = `/annotator/${imagingPatientId}?visit-id=${estimatedVisitId}&unified-id=${unifiedId}`;

  const onReviewRadiographs = () => {
    if (!appointment) return;
    if (
      (
        (appointment.patient.firstName || '') +
        ' ' +
        (appointment.patient.lastName || '')
      ).trim() ||
      appointment.patient?.firstName
    ) {
      setSelectedVisitId(
        appointment.appointment.estimatedVisitId?.toString() ?? null,
      );
      setSelectedUnifiedId(appointment.appointment.unifiedId.toString() ?? '');
      dispatch(
        updateUserName(
          appointment.appointment.unifiedId,
          getDisplayName(appointment, 0).patientName,
        ),
      );
    }
  };

  return { onReviewRadiographs, annotatorUri };
};
